import { Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {
    ViewModelForm,
    ViewModelServiceContext
} from '@xengage/gw-portals-viewmodel-react';
import { SuccessNotification } from 'gw-components-platform-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import AddressSummary from '../AddressSummary/AddressSummary';
import messages from './AgencyDetails.messages';
import metadata from './AgencyDetails.metadata.json5';
import styles from './AgencyDetails.module.scss';

function AgencyDetails(props) {
    const { producerVM, editPrimaryContact, editEftPaymentInfo, editAgencyMailingAddress, userVM} = props;

    // DE15328
    let primaryContact;
    const organization = userVM.organization_EXT;

    if(producerVM.isMasterGroup.value){
        primaryContact = organization.primaryPersonContact || organization.primaryCompanyContact;
    }else{
        primaryContact = producerVM.primaryPersonContact || producerVM.primaryCompanyContact;
    }
    
    // DE15288 setting visibility for EFT Payment Details for TWIA
    const eftStatus = _.get(userVM, 'associationName_TWIA.value.code')
    const translator = useTranslator();

    const editPrimaryContactDetails = useCallback(() => {
        editPrimaryContact(producerVM);
    }, [editPrimaryContact, producerVM]);

    const editAgencyMailingAddressDetails = useCallback(() => {
        editAgencyMailingAddress(producerVM);
    }, [editAgencyMailingAddress, producerVM]);

    const editEftPayments = useCallback(() => {
        editEftPaymentInfo(producerVM);
    }, [editEftPaymentInfo, producerVM]);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        //DE15285- header changes done
        orgTitle: {
            // DE15287
            content: producerVM.isMasterGroup.value ? 
            producerVM.name.value : translator(messages.orgTitle).concat(producerVM.name.value)  
        },
        producerCode: {
            // DE15287
            visible: producerVM.isMasterGroup.value === false,
            content: translator(messages.producerCode).concat(producerVM.producerCode?.code?.value)  
        },
        mailingAddressTitle:{
            content: translator(messages.mailingAddress)
        },
        mailingAddresSummary:{
            address: primaryContact?.primaryAddress?.value
        },
        primaryContactTitle:{
            content: translator(messages.primaryContact)
        },
        displayName:{
            content: primaryContact?.displayName?.value
        },
        emailAddress:{
            content: primaryContact?.emailAddress1?.value
        },
        workNumber:{
            value: primaryContact?.workNumber?.value,
            readOnly: true
        },
        statusTitle: {
            content: translator(messages.status)
        },
        orgStatus: {
            content: producerVM.status.value
        },
        eftDetails:{ // DE15287
            visible: eftStatus === "twia" && !producerVM.isMasterGroup.value
        },
        eftTitle: {
            content: translator(messages.eftPayment)
        },
        eftStatus: {
            content: translator({
                id: `typekey.EFTStatus_TWIA.${_.get(producerVM, 'eftstatus_TWIA.value.code')}`,
                defaultMessage: _.get(producerVM, 'eftstatus_TWIA.value.code'),
            })
        },
        eftAccountNumber: {
            // eslint-disable-next-line no-secrets/no-secrets
            content: _.get(producerVM, 'agentEFT_TWIA.eftaccountNumber.value', ''),
        },
        editEft: {
            visible: producerVM.canEditEFTPaymentsInfo.value
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {   
            addressSummaryComponent: AddressSummary              
        },
        resolveCallbackMap: { 
            editPrimaryContactDetails,
            editEftPayments,
            editAgencyMailingAddressDetails        
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={producerVM}
            overrideProps={overrideProps}
            // onValueChange={handleSearchValueChange}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

AgencyDetails.propTypes = {
    
};

AgencyDetails.defaultProps = {

};

export default AgencyDetails;
